export default {
      id: "whatsapp-24-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "assets/iconset.svg#whatsapp-24",
      toString: function () {
        return this.url;
      }
    }